import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/066685d6-5da5-4bf5-bb1c-50af80a10d53",
    component: _cffe3db6,
    name: "066685d6-5da5-4bf5-bb1c-50af80a10d53"
  }, {
    path: "/103cd55b-4b08-4e79-91d7-04dc0481b652",
    component: _cffe3db6,
    name: "103cd55b-4b08-4e79-91d7-04dc0481b652"
  }, {
    path: "/1d842401-9f44-4071-b54e-56dede1a24aa",
    component: _cffe3db6,
    name: "1d842401-9f44-4071-b54e-56dede1a24aa"
  }, {
    path: "/21f793ed-6ad5-45c6-8e33-8e94fc9994ee",
    component: _cffe3db6,
    name: "21f793ed-6ad5-45c6-8e33-8e94fc9994ee"
  }, {
    path: "/53348819-6cc5-40f9-937a-928470877ed6",
    component: _cffe3db6,
    name: "53348819-6cc5-40f9-937a-928470877ed6"
  }, {
    path: "/72291f12-d46b-4641-a8ba-86c673cc1675",
    component: _cffe3db6,
    name: "72291f12-d46b-4641-a8ba-86c673cc1675"
  }, {
    path: "/7315f117-f2c3-4348-baf3-7f7ac7cdec01",
    component: _cffe3db6,
    name: "7315f117-f2c3-4348-baf3-7f7ac7cdec01"
  }, {
    path: "/7ed6bf98-4c5a-4fa5-a7b6-c0d4147061c6",
    component: _cffe3db6,
    name: "7ed6bf98-4c5a-4fa5-a7b6-c0d4147061c6"
  }, {
    path: "/853a9071-b24b-4789-a07a-fc84b5952106",
    component: _cffe3db6,
    name: "853a9071-b24b-4789-a07a-fc84b5952106"
  }, {
    path: "/9d22c42a-e47c-4637-be71-a3e1c226bd26",
    component: _cffe3db6,
    name: "9d22c42a-e47c-4637-be71-a3e1c226bd26"
  }, {
    path: "/a2822e3e-5b72-49dc-9c08-94fb6072dd4f",
    component: _cffe3db6,
    name: "a2822e3e-5b72-49dc-9c08-94fb6072dd4f"
  }, {
    path: "/b1e245bf-dc79-4446-8079-ae727389d458",
    component: _cffe3db6,
    name: "b1e245bf-dc79-4446-8079-ae727389d458"
  }, {
    path: "/b242b2f0-2b7f-4905-86c6-6349367e2b3d",
    component: _cffe3db6,
    name: "b242b2f0-2b7f-4905-86c6-6349367e2b3d"
  }, {
    path: "/c25060e6-061d-428a-a05e-0e7e2b8daff2",
    component: _cffe3db6,
    name: "c25060e6-061d-428a-a05e-0e7e2b8daff2"
  }, {
    path: "/ca4b25f4-da9f-44af-b6ad-eb4139ab6931",
    component: _cffe3db6,
    name: "ca4b25f4-da9f-44af-b6ad-eb4139ab6931"
  }, {
    path: "/cab6c253-57d7-4d04-a90c-1d6cdcc72b77",
    component: _cffe3db6,
    name: "cab6c253-57d7-4d04-a90c-1d6cdcc72b77"
  }, {
    path: "/contact-us",
    component: _cffe3db6,
    name: "contact-us"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/eea88ed6-bfbd-4819-8c1d-c93af8a27e72",
    component: _cffe3db6,
    name: "eea88ed6-bfbd-4819-8c1d-c93af8a27e72"
  }, {
    path: "/f8297fda-307e-4514-8d5b-a84217b81a96",
    component: _cffe3db6,
    name: "f8297fda-307e-4514-8d5b-a84217b81a96"
  }, {
    path: "/f8844323-453b-45a5-842d-feeda0a19180",
    component: _cffe3db6,
    name: "f8844323-453b-45a5-842d-feeda0a19180"
  }, {
    path: "/ff5f3443-9cae-484b-a8cf-672c9b6f114a",
    component: _cffe3db6,
    name: "ff5f3443-9cae-484b-a8cf-672c9b6f114a"
  }, {
    path: "/about-us/our-team",
    component: _cffe3db6,
    name: "our-team"
  }, {
    path: "/products-services/our-services",
    component: _cffe3db6,
    name: "our-services"
  }, {
    path: "/products-services/products",
    component: _cffe3db6,
    name: "products"
  }, {
    path: "/resources/aarp-life-insurance",
    component: _cffe3db6,
    name: "aarp-life-insurance"
  }, {
    path: "/resources/articles",
    component: _cffe3db6,
    name: "articles"
  }, {
    path: "/resources/calculators",
    component: _cffe3db6,
    name: "calculators"
  }, {
    path: "/resources/life-stages",
    component: _cffe3db6,
    name: "life-stages"
  }, {
    path: "/resources/other-resources",
    component: _cffe3db6,
    name: "other-resources"
  }, {
    path: "/resources/tax-resources",
    component: _cffe3db6,
    name: "tax-resources"
  }, {
    path: "/resources/videos",
    component: _cffe3db6,
    name: "videos"
  }, {
    path: "/resources/articles/3-steps-to-selecting-a-financial-professional",
    component: _cffe3db6,
    name: "3-steps-to-selecting-a-financial-professional"
  }, {
    path: "/resources/articles/4-ways-to-cut-your-tax-bill-in-retirement",
    component: _cffe3db6,
    name: "4-ways-to-cut-your-tax-bill-in-retirement"
  }, {
    path: "/resources/articles/5-reasons-to-see-a-tax-professional",
    component: _cffe3db6,
    name: "5-reasons-to-see-a-tax-professional"
  }, {
    path: "/resources/articles/5-steps-to-financial-freedom-after-divorce",
    component: _cffe3db6,
    name: "5-steps-to-financial-freedom-after-divorce"
  }, {
    path: "/resources/articles/5-steps-to-financial-freedom-after-divorce",
    component: _cffe3db6,
    name: "5-steps-to-financial-freedom-after-divorce"
  }, {
    path: "/resources/articles/7-questions-to-ask-a-financial-professional",
    component: _cffe3db6,
    name: "7-questions-to-ask-a-financial-professional"
  }, {
    path: "/resources/articles/budgeting-for-a-non-budgeter",
    component: _cffe3db6,
    name: "budgeting-for-a-non-budgeter"
  }, {
    path: "/resources/articles/budgeting-for-a-non-budgeter",
    component: _cffe3db6,
    name: "budgeting-for-a-non-budgeter"
  }, {
    path: "/resources/articles/budgeting-for-a-non-budgeter",
    component: _cffe3db6,
    name: "budgeting-for-a-non-budgeter"
  }, {
    path: "/resources/articles/child-education-cost",
    component: _cffe3db6,
    name: "child-education-cost"
  }, {
    path: "/resources/articles/easy-steps-for-starting-a-surprise-fund",
    component: _cffe3db6,
    name: "easy-steps-for-starting-a-surprise-fund"
  }, {
    path: "/resources/articles/easy-steps-for-starting-a-surprise-fund",
    component: _cffe3db6,
    name: "easy-steps-for-starting-a-surprise-fund"
  }, {
    path: "/resources/articles/easy-steps-for-starting-a-surprise-fund",
    component: _cffe3db6,
    name: "easy-steps-for-starting-a-surprise-fund"
  }, {
    path: "/resources/articles/financial-basics-for-your-high-school-graduate",
    component: _cffe3db6,
    name: "financial-basics-for-your-high-school-graduate"
  }, {
    path: "/resources/articles/having-control-over-your-day-to-day-finances",
    component: _cffe3db6,
    name: "having-control-over-your-day-to-day-finances"
  }, {
    path: "/resources/articles/having-control-over-your-day-to-day-finances",
    component: _cffe3db6,
    name: "having-control-over-your-day-to-day-finances"
  }, {
    path: "/resources/articles/having-control-over-your-day-to-day-finances",
    component: _cffe3db6,
    name: "having-control-over-your-day-to-day-finances"
  }, {
    path: "/resources/articles/how-to-get-the-most-out-of-your-extra-cash",
    component: _cffe3db6,
    name: "how-to-get-the-most-out-of-your-extra-cash"
  }, {
    path: "/resources/articles/how-to-protect-your-small-business-from-a-lawsuit",
    component: _cffe3db6,
    name: "how-to-protect-your-small-business-from-a-lawsuit"
  }, {
    path: "/resources/articles/preparing-for-retirement-over-the-decades",
    component: _cffe3db6,
    name: "preparing-for-retirement-over-the-decades"
  }, {
    path: "/resources/articles/retirement-plans-for-small-businesses",
    component: _cffe3db6,
    name: "retirement-plans-for-small-businesses"
  }, {
    path: "/resources/articles/should-you-combine-your-finances-after-getting-married",
    component: _cffe3db6,
    name: "should-you-combine-your-finances-after-getting-married"
  }, {
    path: "/resources/articles/should-you-combine-your-finances-after-getting-married",
    component: _cffe3db6,
    name: "should-you-combine-your-finances-after-getting-married"
  }, {
    path: "/resources/articles/should-you-combine-your-finances-after-getting-married",
    component: _cffe3db6,
    name: "should-you-combine-your-finances-after-getting-married"
  }, {
    path: "/resources/articles/simple-ways-to-provide-financial-wellness-to-employees",
    component: _cffe3db6,
    name: "simple-ways-to-provide-financial-wellness-to-employees"
  }, {
    path: "/resources/articles/starting-a-family-the-total-cost-of-a-baby",
    component: _cffe3db6,
    name: "starting-a-family-the-total-cost-of-a-baby"
  }, {
    path: "/resources/articles/why-the-human-element-matters-in-financial-guidance",
    component: _cffe3db6,
    name: "why-the-human-element-matters-in-financial-guidance"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
